/** The first user-perceived character (grapheme): "മ" of "മലയാളം", "👩‍💻" whole. */
export function firstGrapheme(text: string): string {
  const trimmed = text.trim();
  if (!trimmed) return '';
  if (typeof Intl !== 'undefined' && 'Segmenter' in Intl) {
    const seg = new Intl.Segmenter(undefined, { granularity: 'grapheme' });
    for (const { segment } of seg.segment(trimmed)) return segment;
  }
  return Array.from(trimmed)[0] ?? '';
}

/** The initial shown in an avatar: the first grapheme, upper-cased where the script has case. */
export function avatarInitial(text: string): string {
  return firstGrapheme(text).toLocaleUpperCase();
}
